enum OrderLineType {
  Contingent = 0,
  ServiceFee = 1,
  ContingentDiscount = 2,
  ServiceFeeDiscount = 3,
}

const toCalculationType = (orderLineType: OrderLineType) => {
  switch (orderLineType) {
    case OrderLineType.Contingent:
      return "Contingent";
    case OrderLineType.ContingentDiscount:
      return "Contingent";
    case OrderLineType.ServiceFee:
      return "ServiceFee";
    case OrderLineType.ServiceFeeDiscount:
      return "ServiceFee";
    default:
      throw new Error("Non-existant orderLineType in switch");
  }
};

export const OrderLineTypeUtils = {
  toCalculationType,
};

export default OrderLineType;
